export default {
  charge_record: {
    prop: {
      charging_started_at: '启动时间',
      charging_finished_at: '结束时间',
      consumed_power: '电量',
      consumed_time: '充电时长',
      stop_reason: '停止原因',
      seq: '互联互通编号',
      start_mode: '启动方式',
      stop_mode: '停止方式',
      vin: 'VIN',
      soc: 'SOC',
      user_balance: '下发用户余额'
    },
    start_modes: {
      card_start: '刷卡',
      app_start: 'app启动',
      charger_start: '桩启动',
      platform_start: '平台启动',
      wechat_mini: '微信小程序启动',
      alipay_mini: '支付宝小程序启动',
      vin_start: 'VIN插枪启动'
    },
    stop_mode: {
      title: '终止方式',
      app_request_stop: '用户主动终止',
      app_precondition_stop: '用户预设条件超出',
      charge_completed_stop: '充满终止',
      plug_out_stop: '电桩拔枪终止',
      charger_error_stop: '充电异常',
      charger_offline_stop: '电桩离网',
      reservation_stop: '其他用户预约',
      insufficient_balance_stop: '用户余额不足',
      platform_admin_stop: '平台管理员终止'
    }
  }
}
